module.exports = __webpack_public_path__ + "static/media/avatar18.96459891.png";